'use client'

import type { ReactNode } from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'

export const THEME_OPTIONS = ['light', 'dark', 'system'] as const
export type ThemeOption = (typeof THEME_OPTIONS)[number]

/**
 * Light / Dark / System for the product, persisted per browser
 * (localStorage `theme`). next-themes injects a blocking script that puts the
 * `dark` class on <html> before first paint, so a dark-mode user never sees a
 * light flash.
 *
 * Defaults to light: nobody's app changes until they pick a theme.
 *
 * Marketing pages stay light whatever is picked — globals.css keys the dark
 * tokens and the `dark:` variant off `:root:has(.marketing-theme)`, so no
 * route allowlist is needed here. `color-scheme` is set there too rather than
 * by next-themes, whose inline style on <html> would also darken the form
 * controls and scrollbars of marketing pages.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      enableColorScheme={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  )
}
